import { createContext, useContext } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";

type MobileViewportResult = { isMobileViewport: boolean; isPending: boolean };

/**
 * When provided, overrides the return value of useIsMobileViewport.
 * Used in Storybook to force mobile/desktop layout inside `<Canvas>` embeds
 * where the iframe is not resized to match the viewport global.
 */
const MobileViewportOverrideContext = createContext<MobileViewportResult | null>(null);
export const MobileViewportOverrideProvider = MobileViewportOverrideContext.Provider;

/**
 * A hook that detects if the current viewport is mobile-sized using matchMedia
 * @param query - The media query to match (default: '(max-width: 767px)')
 * @returns True if the media query matches. isPending is always false (kept for API compatibility).
 */
const useIsMobileViewport = (query = "(max-width: 767px)") => {
    const override = useContext(MobileViewportOverrideContext);

    const matches = useMediaQuery(query);

    if (override) {
        return override;
    }

    return { isMobileViewport: matches, isPending: false };
};

export default useIsMobileViewport;
